/**
 * Module dependencies.
 */

import * as LabelPrimitive from '@radix-ui/react-label';
import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from 'app/lib/utils';

/**
 * Label variants (shadcn/ui).
 */

const labelVariants = cva('text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70');

/**
 * Export `Label` component.
 */

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> & VariantProps<typeof labelVariants>
>(({ className, ...props }, ref) => (
  <LabelPrimitive.Root className={cn(labelVariants(), className)} ref={ref} {...props} />
));
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
